module.exports = __webpack_public_path__ + "img/每天只做今日任务_copy1.7623d897.png";